import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import MachineSpecAccordion from "./machineSpecAccordion";

function mapStateToProps(state) {
    return {
        transactions: state.transactions,
        transactionRequest: state.transactionRequest,
        bids: state.bids,
        actionType: state.actionType,
        texts: state.translatedTexts,
        domainDetails: state.domainDetails,
    };
}

function mapDispatchToProps(dispatch) {
    let actionDispatchers = bindActionCreators(actionCreators, dispatch);
    return actionDispatchers;

}
export default connect(mapStateToProps,mapDispatchToProps)(MachineSpecAccordion);